// =============================================================================
// Auth action constants — Phase 4A (auth dual-write scaffolding).
//
// AUTH_LOGIN_SUCCESS         — fired alongside legacy USER_LOGIN_SUCCESS by
//                              login / googleLogin / register thunks. Carries
//                              the raw backend payload (snake_case fields);
//                              the auth reducer projects to its own shape.
//
// AUTH_TOKEN_REFRESH_SUCCESS — fired alongside legacy USER_TOKEN_REFRESH by
//                              the refresh coordinator on successful refresh.
//                              Payload: access (string) — same as legacy.
//
// AUTH_LOGOUT                — fired alongside legacy USER_LOGOUT by the
//                              logout thunk and by performLogout in the
//                              refresh coordinator. Reducer resets the slice
//                              to INITIAL_AUTH_STATE.
//
// IMPORTANT — Phase 4A scope invariant:
//   These actions are SECONDARY REPLICATED state. The canonical auth source
//   of truth remains state.userLogin.userInfo. Consumers must NOT read auth
//   slice as authoritative until Phase 5 selector migration / Phase 6
//   ownership inversion. Any divergence between auth and userInfo during
//   Phase 4A is a bug in the dual-write contract — treat as a bug, do not
//   silently paper over.
// =============================================================================

export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_TOKEN_REFRESH_SUCCESS = 'AUTH_TOKEN_REFRESH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

// AUTH_IDENTITY_PATCH — Phase 4B narrow identity reconciliation.
//
// Dispatched by callers that receive a UserSerializer-shaped payload (no
// access/refresh) from endpoints that may report identity-dimension changes:
//   - validateUserProfile (email verification flips is_email_verified)
//   - bootstrapApp success (server-side identity may have changed since
//     last persist)
//
// PATCH-semantic, NOT REPLACE. See reducer for the full contract — in
// particular this action MUST NEVER touch access/refresh and is restricted
// to a whitelist of 4 identity fields. Reading past those whitelist
// boundaries is a contract violation.
export const AUTH_IDENTITY_PATCH = 'AUTH_IDENTITY_PATCH';
